import React from "react";
import ReactPlayer from "react-player";

const VideoPlayer = ({
  url,
  playing = true,
  loop = false,
  controls = true,
  muted = true,
  playbackRate = 1,
  width,
  height,
  playsinline = false,
  ...props
}) => {
  return (
    <ReactPlayer
      url={url}
      playing={playing}
      loop={loop}
      controls={controls}
      muted={muted}
      playbackRate={playbackRate}
      width={width}
      height={height}
      playsinline={playsinline}
      {...props}
    />
  );
};

export default VideoPlayer;
